import { render, staticRenderFns } from "./CreateAttendanceKidDetailExcelOld.vue?vue&type=template&id=ba04465e&scoped=true"
import script from "./CreateAttendanceKidDetailExcelOld.vue?vue&type=script&lang=js"
export * from "./CreateAttendanceKidDetailExcelOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba04465e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba04465e')) {
      api.createRecord('ba04465e', component.options)
    } else {
      api.reload('ba04465e', component.options)
    }
    module.hot.accept("./CreateAttendanceKidDetailExcelOld.vue?vue&type=template&id=ba04465e&scoped=true", function () {
      api.rerender('ba04465e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateAttendanceKidDetailExcelOld.vue"
export default component.exports